import { NavLink, Outlet } from "react-router-dom";
import { useState } from "react";
import { SeeAll } from "../Components/SeeAll";
import { useOutletContext } from "react-router-dom";

export const DirectTrade = () => {
  const [selectedNavlink, setSelectedNavlink] = useState(1);
  const NavLinkStyleBuy = ({ isActive }) => {
    return `text-center py-2 px-2 md:px-6 font-pin rounded text  ${
      isActive ? "bg-green-500 font-semibold text-p-wh" : "font-medium"
    }`;
  };
  const NavLinkStyleSell = ({ isActive }) => {
    return `text-center py-2 px-2 md:px-6 font-pin rounded text  ${
      isActive ? "bg-red-500 font-semibold text-p-wh" : "font-medium"
    }`;
  };

  const handleNavLinkSelected = (id) => {
    setSelectedNavlink(id);
  };

  return (
    <div className="flex  flex-col gap-16 max-w-4xl pb-32 mx-6 md:mx-auto px-4 md:px-6">
      <div className="flex flex-row justify-between items-end border-b-[0.5px] pb-4">
        <h3 className="text-[1rem] md:text-[1.128rem] font-semibold">
          Direct Trade
        </h3>

        <nav className="flex flex-row items-center border-[0.4px] rounded">
          <NavLink
            to="buy"
            className={NavLinkStyleBuy}
            onClick={() => handleNavLinkSelected(1)}
          >
            Buy CX
          </NavLink>
          <NavLink
            to="sell"
            className={NavLinkStyleSell}
            onClick={() => handleNavLinkSelected(2)}
          >
            Sell CX
          </NavLink>
        </nav>
      </div>

      <Outlet context={{ selectedNavlink }} />
    </div>
  );
};
